"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = void 0;
const get_zaraz_1 = require("../helpers/get-zaraz");
/**
 * Get the current consent status for a purpose using the purpose ID.
 *
 * ```
 * true: The consent was granted.
 * false: The consent was not granted.
 * undefined: The purpose does not exist.
 * ```
 */
function get(purposeId) {
    return (0, get_zaraz_1.getZaraz)().consent.get(purposeId);
}
exports.get = get;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnNlbnQvZ2V0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG9EQUFnRDtBQUVoRDs7Ozs7Ozs7R0FRRztBQUNILFNBQWdCLEdBQUcsQ0FBQyxTQUFpQjtJQUNuQyxPQUFPLElBQUEsb0JBQVEsR0FBRSxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsU0FBUyxDQUFDLENBQUM7QUFDM0MsQ0FBQztBQUZELGtCQUVDIn0=